import React from "react";
import createDataContext from "./createDataContext";
import { auth, admin, firestore } from "../api/firebase";
import Typography from "@material-ui/core/Typography";

const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const authReducer = (state, action) => {
  switch (action.type) {
    case "set_error":
      return { ...state, error: action.payload, confirmationMessage: "" };
    case "clear_error_message":
      return { ...state, error: "" };
    case "confirm_email_sent":
      return { ...state, confirmationMessage: action.payload, error: "" };
    case "set_local_email":
      return { ...state, error: "", email: action.payload };
    default:
      return state;
  }
};

const signin = (dispatch) => async ({ email, password, history }) => {
  if (email && password) {
    try {
      let { user } = await auth.signInWithEmailAndPassword(email, password);
      const token = await user.getIdTokenResult();
      if(token.claims.admin === true){
        history.push("/dashboard");
        dispatch({ type: "set_local_email", payload: user.email });
        await createLog(user.uid, "IN");
      }
      else{
        auth.signOut();
        let errorMessage = "Cuenta inválida"
        const errorComponent = (
          <Typography component="p" color="error" variant="body2">
            {errorMessage}
          </Typography>
        );
        dispatch({ type: "set_error", payload: errorComponent });
      }
    } catch (error) {
      let errorMessage = "";
      switch (error.code) {
        case "auth/invalid-email":
          errorMessage = "Email inválido";
          break;
        case "auth/user-disabled":
          errorMessage = "Esta cuenta está desactivada";
          break;
        case "auth/user-not-found":
          errorMessage = "No existe una cuenta con este correo.";
          break;
        case "auth/wrong-password":
          errorMessage = "Contraseña incorrecta";
          break;
        default:
          errorMessage = "Ocurrió un problema intente más tarde.";
          break;
      }
      const errorComponent = (
        <Typography component="p" color="error" variant="body2">
          {errorMessage}
        </Typography>
      );
      dispatch({ type: "set_error", payload: errorComponent });
    }
  } else {
    const errorComponent = (
      <Typography component="p" color="error" variant="body2">
        Missing Values.
      </Typography>
    );
    dispatch({ type: "set_error", payload: errorComponent });
  }
};

const sendRecoveryEmail = (dispatch) => async ({ email }) => {
  if (email && email.length > 0) {
    if (emailRegEx.test(email)) {
      try {
        await auth.sendPasswordResetEmail(email);
        dispatch({ type: "confirm_email_sent", payload: "El correo fue enviado." });
      } catch (error) {
        let errorMessage = "";
        switch (error.code) {
          case "auth/invalid-email":
            errorMessage = "El correo no es válido.";
            break;
          case "auth/user-not-found":
            errorMessage = "No existe una cuenta con este correo.";
            break;
          default:
            errorMessage = "El correo no pudo enviarse, intente más tarde.";
            break;
        }
        const errorComponent = (
          <Typography component="p" color="error" variant="body2">
            {errorMessage}
          </Typography>
        );
        dispatch({ type: "set_error", payload: errorComponent });
      }
    } else {
      const errorComponent = (
        <Typography component="p" color="error" variant="body2">
          Correo Inválido
        </Typography>
      );
      dispatch({ type: "set_error", payload: errorComponent });
    }
  } else {
    const errorComponent = (
      <Typography component="p" color="error" variant="body2">
        Ingresa una dirección de correo.
      </Typography>
    );
    dispatch({ type: "set_error", payload: errorComponent });
  }
};

const signout = (dispatch) => async () => {
  await createLog("NULL", "OUT");
  auth.signOut();
};

const createLog= async (id, code)=>{
  let currentUser = auth.currentUser;
  if (currentUser) {
    await firestore.collection("logs").doc().set({
      date: admin.firestore.Timestamp.fromDate(new Date()),
      user: currentUser.uid,
      code,
      id
    })
  }
}

export const { Provider, Context } = createDataContext(
  authReducer,
  { signout, signin, sendRecoveryEmail },
  { error: "", confirmationMessage: "", email: "" }
);
